declare namespace $ {

	type $mol_button_major__sub_shm_hitalama_map_method_source_view_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_map_method_source_view_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_method_source_view['export'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_method_source_view_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_method_source_view_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_method_source_view['import'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_method_source_view_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_method_source_view_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_method_source_view['layout_methods'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_method_source_view_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_textarea__hint_shm_hitalama_map_method_source_view_8 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_textarea['hint'] >
	>
	type $shm_hitalama_textarea__sidebar_showed_shm_hitalama_map_method_source_view_9 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['sidebar_showed'] >
	>
	type $shm_hitalama_textarea__value_shm_hitalama_map_method_source_view_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_method_source_view['source'] >
		,
		ReturnType< $shm_hitalama_textarea['value'] >
	>
	type $shm_hitalama_textarea__spellcheck_shm_hitalama_map_method_source_view_11 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['spellcheck'] >
	>
	export class $shm_hitalama_map_method_source_view extends $mol_page {
		Export_icon( ): $mol_icon_upload
		export( next?: any ): any
		Export( ): $mol_button_major
		Import_icon( ): $mol_icon_download
		import( next?: any ): any
		Import( ): $mol_button_minor
		Layout_methods_icon( ): $mol_icon_apps
		layout_methods( next?: any ): any
		Layout_methods( ): $mol_button_minor
		Tools( ): $mol_view
		source( next?: string ): string
		Source( ): $shm_hitalama_textarea
		map( ): $shm_hitalama_map
		head( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map